const topics = [
  { label: '最新国产大片', hot: true },
  { label: '悬疑推理', hot: true },
  { label: '动作枪战', hot: false },
  { label: '喜剧搞笑', hot: true },
  { label: '文艺剧情', hot: false },
  { label: '历史战争', hot: false },
  { label: '科幻奇幻', hot: true },
  { label: '爱情都市', hot: false },
  { label: '动画国漫', hot: true },
  { label: '纪录片', hot: false },
  { label: '网播热剧', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center">
          热门话题
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          大家都在关注的国产电影话题，看看哪些类型最受欢迎
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#cards');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className={`inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-200 text-foreground-600 hover:bg-background-300'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <span className="flex items-center justify-center w-4 h-4">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}